/** Presentation only: don't let a failed/incomplete query look like an empty account. */
export default function QueryUnavailable({ name }: { name: string }) {
  return <section role="alert" className="rounded-lg border border-line bg-surface p-6 text-ink">
    <h2 className="text-lg font-semibold">{name} unavailable</h2>
    <p className="mt-2 max-w-xl text-sm text-ink-muted">Some data couldn't be loaded in full. Figures and records are hidden here so an incomplete result isn't mistaken for an empty one. Please reload to try again.</p>
  </section>;
}
